import types from '../mutation-types';

const state = {
  guidance: {
    state: '',
  },
};

export const getters = {
  getGuidance($state) {
    return $state.guidance;
  },
};

export const actions = {
  modifyGuidance: ({ commit }, data) => {
    commit(types.SET_BOTIFY_GUIDANCE, data);
  },
  reset: ({ commit }) => {
    commit(types.SET_BOTIFY_GUIDANCE, { state: '' });
  },
};

export const mutations = {
  [types.SET_BOTIFY_GUIDANCE]($state, data) {
    $state.guidance = {
      ...$state.guidance,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
